import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { WorkTimeDetailsDayBookingForm } from "../workTimeBeta/workTimeDetailsDayBookingForm";
import { DayBookingItemBeta } from "../../models/dayBooking/dayBookingItemBeta";
import { useAppDispatch, useAppSelector } from "../../framework/customStore";
import { fetchGroupedCostCenterOptions } from "../../store/costCenterSlice";
import { fetchVehicleOptions } from "../../store/vehicleSlice";
import { fetchDayBookings } from "../../store/workShiftPlanningSlice";

interface DayBookingDialogProps {
    open: boolean;
    onClose: () => void;
    employeeId?: string;
    date?: string;
    costCenterId?: string;
    vehicleId?: string;
    onSaved?: (saved?: DayBookingItemBeta) => void;
}

export default function DayBookingDialog({ open, onClose, employeeId, date, costCenterId, vehicleId, onSaved }: DayBookingDialogProps) {
    const { t } = useTranslation();
    const [editDayBookingItem, setEditDayBookingItem] = useState<DayBookingItemBeta | null>(null);
    const dispatch = useAppDispatch();
    const costCenters = useAppSelector(state => state.costCenter.groupedOptions);
    const vehicleOptions = useAppSelector(state => state.vehicle.options);

    const handleAfterSave = () => {
        if (onSaved) {
            onSaved();
        } else {
            if (date && employeeId) {
                void dispatch(fetchDayBookings({ startDate: date, endDate: date, employeeIds: [employeeId] }) as any);
            }
        }

        onClose();
    };

    useEffect(() => {
        if (open) {
            if (!costCenters) {
                void dispatch(fetchGroupedCostCenterOptions());
            }
            if (!vehicleOptions) {
                void dispatch(fetchVehicleOptions());
            }
        }
    }, [open, costCenters, vehicleOptions, dispatch]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                {t("common.newDayBooking")}
                <IconButton aria-label="close" onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }} size="large">
                    <CloseIcon fontSize="small" />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <WorkTimeDetailsDayBookingForm
                    afterSave={handleAfterSave}
                    editDayBookingItem={editDayBookingItem}
                    setEditDayBookingItem={setEditDayBookingItem}
                    costCenterId={costCenterId}
                    vehicleId={vehicleId}
                    employeeId={employeeId}
                    date={date}
                />
            </DialogContent>
        </Dialog>
    );
}
